"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class IS {
}
exports.default = IS;
IS.array = (data) => Array.isArray(data);
IS.date = (data) => data instanceof Date;
IS.blob = (data) => data instanceof Blob;
IS.string = (data) => typeof data === 'string';
IS.number = (data) => typeof data === 'number';
IS.boolean = (data) => typeof data === 'boolean';
IS.object_only = (data) => typeof data === 'object';
IS.function = (data) => typeof data === 'function';
IS.object = (data) => typeof data === 'object' && !Array.isArray(data);
